var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 12.2",
    style: {
      enableBackground: "new 0 0 16 12.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1,6.6h0.9v0.9H16V5.6h-1.9V6.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,5.6h1.9v0.9h-1.9V5.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,5.6h1.9v0.9H8.5V5.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,5.6h1.9v0.9H5.6V5.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,5.6h1.9v0.9H2.8V5.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,7.5h0.9V6.6h0.9V5.6H0V7.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,10.4v0.9h-0.9v0.9H16v-1.9H15.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,10.4H0v1.9h1.9v-0.9H0.9L0.9,10.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,11.3h1.9v0.9h-1.9V11.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,11.3h1.9v0.9H8.5V11.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,11.3h1.9v0.9H5.6V11.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,11.3h1.9v0.9H2.8V11.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,8.5h0.9v0.9H0V8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,8.5H16v0.9h-0.9V8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,7.7L3.8,8.3L3.2,7.7L2.5,8.3L3.2,9L2.5,9.7l0.7,0.7l0.7-0.7l0.7,0.7l0.7-0.7L4.5,9l0.7-0.7L4.5,7.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,7.7L8,8.3L7.4,7.7L6.7,8.3L7.4,9L6.7,9.7l0.7,0.7L8,9.7l0.7,0.7l0.7-0.7L8.7,9l0.7-0.7L8.7,7.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,7.7l-0.7,0.7l-0.7-0.7l-0.7,0.7L11.5,9l-0.7,0.7l0.7,0.7l0.7-0.7l0.7,0.7l0.7-0.7L12.8,9l0.7-0.7 L12.8,7.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,4.7h0.1c0.9,0,1.6-0.7,1.6-1.6V2.8H2.4v0.3c0,0.4-0.3,0.6-0.6,0.6H1.6c-0.4,0-0.6-0.3-0.6-0.6V1.6 c0-0.4,0.3-0.6,0.6-0.6h0.1c0.4,0,0.6,0.3,0.6,0.6v0.3h0.9V1.6C3.3,0.7,2.6,0,1.7,0H1.6C0.7,0,0,0.7,0,1.6v1.5 C0,4,0.7,4.7,1.6,4.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,1.6c0-0.4,0.3-0.6,0.6-0.6h0.1c0.4,0,0.6,0.3,0.6,0.6v1.5c0,0.4-0.3,0.6-0.6,0.6H5.8 c-0.4,0-0.6-0.3-0.6-0.6V1.6z M5.8,4.7h0.1c0.9,0,1.6-0.7,1.6-1.6V1.6C7.5,0.7,6.8,0,5.9,0H5.8C4.9,0,4.2,0.7,4.2,1.6v1.5 C4.2,4,4.9,4.7,5.8,4.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,0.9h0.8c0.4,0,0.6,0.3,0.6,0.6v1.5c0,0.4-0.3,0.6-0.6,0.6H9.4V0.9z M11.8,3.1V1.6 c0-0.9-0.7-1.6-1.6-1.6H8.5v4.7h1.7C11.1,4.7,11.8,4,11.8,3.1L11.8,3.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0.9V0h-3.3v4.7H16V3.8h-2.4V2.8h1.7V1.9h-1.7V0.9L16,0.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigCode);
export default __webpack_public_path__ + "static/media/config_code.838dc5f255973f90a3b5a3e6beac5086.svg";
export { ForwardRef as ReactComponent };